export default "__VITE_ASSET__8974da54__"